<template>
 <div :class="windowClass">
        <v-row no-gutters>
            <v-col md="8"
            offset-md="2"
            class="pa-1">
                    <p class="pt-3 subtitle-2"><v-icon>mdi-fish</v-icon> TODAY'S SUPPLIES </p>
                    <v-card class="pa-2">
                        <v-toolbar elevation="0">
                      
                        <v-autocomplete
                        v-model="supplier"
                            label="Filter By Fishcar"
                            :items="suppliers"
                            item-text="name"
                            item-value="id"
                            return-object=""
                            filled
                            @change="search=supplier.name"
                            dense
                            single-line
                            hide-details
                        />
                        <v-spacer/>
                        <v-btn  @click="form=true"  color="success">  <v-icon left >mdi-plus-box</v-icon>Add Supply</v-btn>
                       
                        </v-toolbar>
                        <v-divider/>
                        <div class="text-center pa-4" v-if="loader">
                             <v-progress-circular
      :width="3"
      color="red"
      indeterminate
    ></v-progress-circular>
                        </div>
                             <v-data-table
                                class="va-table"
                                :headers="headers"
                                :items-per-page="100"
                                hide-default-footer
                                hide-default-header
                                :search="search"
                                :items="SUPPLIES"
                                >
                                <template v-slot:body="{ items }">
                                    <tbody>
                                    <tr v-for="(item,index) in items" :key="index">
                                            <td>
                                            {{ item.name }}
                                            <br /><small>{{ item.description }}</small>
                                            </td>
                                            <td>{{ item.fishcar }}</td>
                                            <td>
                                                <v-switch
                                                class="mt-0"
                                                small
                                                v-model="item.status"
                                                @change="kind = item, UpdateStatus()"
                                                color="success"
                                                value="available"
                                                hide-details
                                                ></v-switch>
                                            </td>
                                    </tr>
                                    </tbody>
                                </template>
                          </v-data-table>
                    </v-card>
            </v-col>
           
        </v-row>
   <va-supply-form :show="form" :suppliers="suppliers" :kinds="kinds" @DialogEvent="formEvent"/>
  </div>
</template>
<script>
import { API_MIXINS } from '@/mixins/api_mixins.js'
import {
  mapMutations
} from 'vuex'
  export default {
    mixins: [API_MIXINS],
    data: () => ({
        form: false,
        search:'',
        kind:{},
        loader: false,
        state:'new',
        kinds:[],
        suppliers:[],
        supplier:{},
        headers: [
            { text: 'Name'},
            { text: 'Description'},
            { text: 'Fishcar', value:'fishcar'},
             { text: 'Status'}
        ],
        selected_date: ''
    }),
    beforeCreate: function () {
      if (!this.$session.exists()) {
        this.$router.push('/')
      }
    },
    created() {
       if (this.$session.exists()) {
          this.$http.defaults.headers.common['Authorization'] = 'Bearer ' + this.$session.get('jwt')
          this.setLoggedIn(true) 
          this.selected_date = this.$moment().format('YYYY-MM-DD')
          this.getSuppliers()
          this.getKinds()
          this.getSupplies()
        }
    },
    computed:{
       windowClass() {
        if(this.$store.state.responsive){
          return "va-reponsive"
        } else {
          return "va-not-reponsive"
        }
      },
      SUPPLIES() {
        return this.$store.state.supplies
      },
    },
    methods: {
      ...mapMutations(['setAlert', 'setAlertColor', 'setAlertText', 'setLoggedIn']),
      formEvent(data){
          this.form = false
          if(data.action != 'close') {
              this.addSupplies(data.supplies)
          }
      },
      addSupplies(items){
        for(let i=0; i<items.length;i++) {
            this.AddItem(items[i])
        }
        setTimeout(()=>{this.getSupplies()}, 1000)
      },
      AddItem: function(item) {
        this.$http.post("product/new", JSON.stringify(item)).then(response => {
            console.log(response.data.status)
               
          }).catch(e => {
           console.log(e)
         })
     },
      UpdateStatus: function() {
            if(this.kind.status == null)
                this.kind.status = "not available"

            this.$http.post("product/update", JSON.stringify(this.kind)).then(response => {
                response.data.status? this.setAlertColor('success'): this.setAlertColor('error')
                this.setAlertText(response.data.message)
                this.setAlert(true)
            }).catch(e => {
                console.log(e.data)
            })
        },
      getSupplies() { 
        this.loader = true
        this.GET_SUPPLIES(this.selected_date, this.selected_date)
        setTimeout(()=>{ this.loader=false },1500)
     },
      getKinds() {
           this.$http.post("category/list", JSON.stringify({})).then(response => {
               response.data.data != null?this.kinds = response.data.data:this.kinds=[]
          }).catch(e => {
           console.log(e)
         })
      },
      getSuppliers: function() { 
             this.$http.post("supplier/list", JSON.stringify({})).then(response => {
              response.data.data != null?this.suppliers = response.data.data:this.suppliers = []
          }).catch(e => {
           console.log(e.data)
         })
     },
    }
  }
</script>